import { React, useState } from "react";
import { Button, Form, Input, Select, Col, Row, Checkbox, Radio,AutoComplete, Tooltip } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  DropDownSearchDraw
} from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import { DatePicker } from "antd";
import { DatePickerY, GlobalSet, DisabledStyles } from "../../pageStyled";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertBlue from "../../../Assets/Icons/alertBlue.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import alertYellow from "../../../Assets/Icons/alertYellow.svg";
import warning from "../../../Assets/Icons/warning.png";
import { useEffect } from "react";
import {
  getAllOrdersListByOrderno,
  getPosDetails,
  rejectOrApproveOrder,
  updateOrder,
  updateIncompleteOrder,
  getAllDeckleMatchingOrdersListByOrderno
} from "../../../Services/orderServices";
import moment from "moment";
import { ModalPopup } from "../../../Components/Modal/modal";
import { DeliveryaddressSpacing } from "../../pageStyled";
import { Country, State } from "country-state-city";
import {
  getProductDetails,
  getProductsData,
} from "../../../Services/productServices";
import { getMachineGradeSelect,getReelCoreValues } from "../../../Services/settingsServices";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";
import { Collapse } from 'antd';
import { 
  weight_Unit_Conversions, 
  orderDim_Rewinder_Unit_Conversion, 
  currency_List, 
  conversionFactorTonneToUnits, 
  CoversionFactorCMToUnits,
  lengthUnit, 
  weightUnit } from "../../../Utils/Constant/MeasurementUnitList";
import { getUnitData } from "../../../Services/measurementService";

const { Option } = Select;
const grainTypeData = ["Long Grain", "Short Grain"];
const orderTypeData = [
  { label: "Reel", value: "reel" },
  { label: "Sheet", value: "sheet" },
];
const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);
const { TextArea } = Input;
const { Panel } = Collapse;

const ResendApprovalData = (props) => {
    const [checkedBox, setCheckedBox] = useState(false);
    const [cities, setCities] = useState([]);
    const [orderDetails, setOrderDetails] = useState();
    const [details, setDetails] = useState();
    const [poDetails, setPoDetails] = useState({});
    const [form] = Form.useForm();
    const [products, setProducts] = useState([]);
    const [orderQuantityTab, setOrderQuantityTab] = useState();
    const [orderMangtSettings , setOrderMangtSettings] = useState();
    const [deckleMangtSettings , setDeckleMangtSettings] = useState();
    const [isProductDropdownOpen, setProductDropdown] = useState(false);
    const [isCountryDropdownOpen, setCountryDropdown] = useState(false);
    const [isStateDropdownOpen, setStateDropdown] = useState(false);
    const [rewinderDia, setRewinderDia] = useState(false);
    const [reelCoreData , setReelCoreData] = useState();
    const [reelValues,setReelvalues] = useState();
    const [coreValues , setCoreValues] = useState();
    const [orderTypes, setOrderTypes] = useState([]);
    const [grainValue, setGrain] = useState("");
    const [mixedGrain, setMixedGrain] = useState(false);
    const [grainChanges, setGrainChanges] = useState(false);
    const [lengthValue, setLength] = useState("");
    const [widthValue, setWidth] = useState("");
    const [orderQuantity, setOrderQuantity] = useState("weight");
    const [weightValue, setWeight] = useState("");
    const [quantityValue, setQuantity] = useState("");
    const [coreOD, setCoreod] = useState("");
    const [reelOD, setReelod] = useState("");
    const [price, setPrice] = useState("");
    const [widthUnitChange, setWidthUnitChange] = useState("");
    const [reelCoreUnitChange, setReelCoreUnitChange] = useState("");
    const [coreOdValidationError, setCoreOdValidationError] = useState(false);
    const [isTouched, setIsTouched] = useState(false);
    const [plannedReels, setPlannedReels] = useState(0);
    const [plannedWeight, setPlannedWeight] = useState(0);
    const [isRewinderReelChanged, setRewinderReelChanged] = useState(false);
    const [isDefaultTolEnabled, setIsDefaultTolEnabled] = useState(false);
    const [upperTolerance, setUpperTolerance] = useState("");
    const [lowerTolerance, setLowerTolerance] = useState("");
    const [defaultUpperTol, setDefaultUpperTol] = useState("");
    const [defaultLowerTol, setDefaultLowerTol] = useState("");
    const [settingsData, setSettings] = useState([]);
    const [isFirstLoad, setFirstLoad] = useState(false);
    const [isVisibleApprovalModal, setIsVisibleApprovalModal] = useState({
      visible: false,
      data: {},
    });

    const [productData, setProductData] = useState({
        bulk: "",
        gsm: "",
    });
    const [weightUnitList, setWeightUnitList] = useState([]);
    const [weightUnitChange, setWeightUnitChange] = useState("");
    const [unitPlaceholder, setUnitPlaceholder] = useState("");
    const [measurementData, setMeasurementData] = useState();
    const [dimesionUnitList, setDimesionUnitList] = useState([]);
    const [rewinderDimUnitList, setReiwnderDimUnitList] = useState([]);
    const [currencyUnitData, setCurrencyUnitData] = useState([]);
    const [priceUnit, setPriceUnit] = useState("");

    const OnProductToggleSelect =()=>{
        setProductDropdown((prevState) => !prevState)
    }

    const handleProduct = async (e) => {
        await getProductDetails(e)
          .then((response) => {
            form.setFieldsValue({ product_spec: response?.data?.product_spec });
            if(e === orderDetails?.product){
              setPriceUnit(orderDetails.units.per_weight_unit);
            } else{
              setPriceUnit(response?.data?.units?.per_weight_unit);
            }            
            setProductData({
              bulk: `${response?.data?.bulk}`,
              gsm: `${response?.data?.gsm}`,
            });
          })
          .catch((error) => {
            console.log("Error in getting product specification list");
          });
    };

    const handleType = (e) => {
        form.resetFields(["width","weight","length","quantity"]);
        form.setFieldsValue({quantity:'',weight:'',length:'',width:'',reel_od:'',core_od:'',planned_weight:'',no_of_reel_sheet:'',price:'',grain:'',net_price:''});
        setGrain("");
        setWidth("");
        setLength("");
        setWeight("");
        setQuantity("");
        setCoreod("");
        setReelod("");
        setPrice("");
        setCoreod("");
        setReelod("");
        setDefaultLowerTol("");
        setDefaultUpperTol("");
        setUpperTolerance("");
        setLowerTolerance("");
        setPlannedWeight(0);
        setRewinderDia(false);
        setMixedGrain(false);
        setGrainChanges(false);
        setCoreOdValidationError(false);
        setRewinderReelChanged(false);
        setWidthUnitChange(measurementData.data.units_management.length.default);
        setReelCoreUnitChange(measurementData.data.units_management.length.default);
        setWeightUnitChange(measurementData.data.units_management.weight.default);
        setUnitPlaceholder(measurementData.data.units_management.weight.default);
        setOrderQuantity("weight");
        form.setFieldsValue({widthUnit: measurementData.data.units_management.length.default});
        form.setFieldsValue({unit: measurementData.data.units_management.length.default});
        form.setFieldsValue({weightUnit: measurementData.data.units_management.weight.default});
        form.setFieldsValue({currency: measurementData.data.units_management.currency.default})
        if(e === "sheet" && orderDetails?.type === "sheet"){
          form.setFieldsValue({upper_tolerance: orderDetails?.upper_tolerance});
          form.setFieldsValue({lower_tolerance: orderDetails?.lower_tolerance});
          setDefaultUpperTol(orderDetails?.upper_tolerance);
          setDefaultLowerTol(orderDetails?.lower_tolerance);
          setUpperTolerance(orderDetails?.calculated_upper_tolerance);
          setLowerTolerance(orderDetails?.calculated_lower_tolerance);
        }

        if(e === "reel"){
          // if(reelCoreData?.default_core_id){
          //   form.setFieldsValue({core_od : reelCoreData.default_core_id});
          //   setCoreod(reelCoreData?.default_core_id);
          // }
          // if(reelCoreData?.default_reel_od){
          //   form.setFieldsValue({reel_od : reelCoreData?.default_reel_od});
          //   setReelod(reelCoreData?.default_reel_od);
          // }

          let onlyDefaultCoreDia = false;
          let defaultUnitSet = false;

        if(((reelCoreData.default_reel_od && reelCoreData.default_core_id) || (reelCoreData.default_reel_od && !reelCoreData.default_core_id)) && e === 'reel'){
          form.setFieldsValue({unit: reelCoreData.default_reel_unit});
        } else if(!reelCoreData.default_reel_od && reelCoreData.default_core_id && e === 'reel'){
          form.setFieldsValue({unit: reelCoreData.default_core_unit});
          onlyDefaultCoreDia = true;
        } else if(!reelCoreData.default_reel_od && !reelCoreData.default_core_id && e === 'reel'){
          form.setFieldsValue({unit: measurementData.data.units_management.length.default});
          defaultUnitSet = true;
        }

          if(reelCoreData.default_core_id) {
            let coreDiaValue;
            if(onlyDefaultCoreDia){
              let conversionInCM =  reelCoreData.default_core_id * orderDim_Rewinder_Unit_Conversion[reelCoreData.default_core_unit];
              coreDiaValue = conversionInCM  * CoversionFactorCMToUnits[reelCoreData.default_core_unit];
            } else if(defaultUnitSet){
              let conversionInCM =  reelCoreData.default_core_id * orderDim_Rewinder_Unit_Conversion[reelCoreData.default_core_unit];
              coreDiaValue = conversionInCM  * CoversionFactorCMToUnits[measurementData.data.units_management.length.default];
            } else{
              let conversionInCM =  reelCoreData.default_core_id * orderDim_Rewinder_Unit_Conversion[reelCoreData.default_core_unit];
              coreDiaValue = conversionInCM  * CoversionFactorCMToUnits[reelCoreData.default_reel_unit];
            }
            form.setFieldsValue({core_od: coreDiaValue?.toFixed(3) })
            setCoreod(coreDiaValue?.toFixed(3));
          }
          if(reelCoreData.default_reel_od){
            let reelDiaValue;
            if(defaultUnitSet){
              let conversionInCM =  reelCoreData.default_reel_od * orderDim_Rewinder_Unit_Conversion[reelCoreData.default_reel_unit];
              reelDiaValue = conversionInCM  * CoversionFactorCMToUnits[measurementData.data.units_management.length.default];
            } else{
              let conversionInCM =  reelCoreData.default_reel_od * orderDim_Rewinder_Unit_Conversion[reelCoreData.default_reel_unit];
              reelDiaValue = conversionInCM  * CoversionFactorCMToUnits[reelCoreData.default_reel_unit];
            }
            form.setFieldsValue({reel_od: reelDiaValue?.toFixed(3) });
            setReelod(reelDiaValue?.toFixed(3));
      }
        }

        setOrderQuantityTab([
          { label: "Weight", value: "weight" },
          {
            label: `${capitalize(e)}s`,
            value: e,
          },
        ]);
    };

    const onGrainChange = (e) => {
        form.setFieldsValue({grain: e});
        setGrain(e);
    };

    const mixedGrainHandler = (e) => {
        setMixedGrain(e.target.checked);
    }

    const grainChangesHandler = (e) => {
        setGrainChanges(e.target.checked);
    }

    const onLengthChange = async (e) => {
        setLength(e.target.value);
        form.setFieldsValue({length: e.target.value});
    };

    const onWidthChange = async (e) => {
        setWidth(e.target.value);
        form.setFieldsValue({width: e.target.value});
    };

    const onWidthUnitChange = async (e) => {
        setWidthUnitChange(e);
        form.setFieldsValue({widthUnit: e});
    };

    const handleQuantityChange = (e) => {
        setQuantity("");
        setWeight("");
        setPlannedReels(0);
        setPlannedWeight("");
        form.setFieldsValue({weight: ""});
        form.setFieldsValue({quantity: ""});
        form.setFieldsValue({no_of_reel_sheet:""});
        form.setFieldsValue({planned_weight:""});
        form.setFieldsValue({weightUnit: measurementData.data.units_management.weight.default});
        setUnitPlaceholder(measurementData.data.units_management.weight.default);
        setOrderQuantity(e.target.value);
        setRewinderReelChanged(false);
    };

    const handleWeight = (e) => {
        setWeight(e.target.value);
        form.setFieldsValue({weight: e.target.value});
    };

    const onQuantityChange = (e) => {
        setQuantity(e.target.value);
        form.setFieldsValue({quantity: e.target.value});
    };

    const checkBoxChange = (event) => {
        setRewinderDia(event.target.checked);
    };

    const validateDefaultCoreOdReelOd = (coreOD, reelOD) => {
      form.setFieldsValue({core_od: coreOD });
      form.setFieldsValue({reel_od: reelOD });
      if ( form.getFieldValue("reel_od") && form.getFieldValue("core_od") && (parseFloat(form.getFieldValue("reel_od")) < parseFloat(form.getFieldValue("core_od")))){
        setCoreOdValidationError(true);
      } else{
        setCoreOdValidationError(false);
      }
    }

    const validateCoreOdReelOd = (event,type) => {
        if (form.getFieldValue("type") === "reel") {
          if (type == "coreOD") {
            let core_value;
            let coreUnit = event.split(" ")[1];
            if(coreUnit){
              let conversionInCM = event.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[coreUnit];
              let rewinderDimUnit = form.getFieldValue("unit");
              core_value = (conversionInCM  * CoversionFactorCMToUnits[rewinderDimUnit] && (conversionInCM  * CoversionFactorCMToUnits[rewinderDimUnit]).toFixed(3));
            } else{
              core_value  = event;
            }
            form.setFieldsValue({ core_od: core_value });
            setCoreod(core_value);
          } else {
            let reel_value;
            let reelUnit = event.split(" ")[1];
            if(reelUnit){
              let conversionInCM = event.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[reelUnit];
              let rewinderDimUnit = form.getFieldValue("unit");
              reel_value = (conversionInCM  * CoversionFactorCMToUnits[rewinderDimUnit] && (conversionInCM  * CoversionFactorCMToUnits[rewinderDimUnit]).toFixed(3));
            } else{
              reel_value  = event;
            }
            form.setFieldsValue({ reel_od: reel_value });
            setReelod(reel_value);
          }
        } else{
            if(type =="coreOD"){
              form.setFieldsValue({core_od: event.target.value });
              setCoreod(event.target.value);
            } else{
              form.setFieldsValue({reel_od: event.target.value });
              setReelod(event.target.value);
            }
        }

        if (form.getFieldValue("reel_od") && form.getFieldValue("core_od") && (parseFloat(form.getFieldValue("reel_od")) < parseFloat(form.getFieldValue("core_od")))){
          setCoreOdValidationError(true);
        } else{
          setCoreOdValidationError(false);
        }        
    };

    const onCoreReelUnitChange = async (e) => {
        setReelCoreUnitChange(e);
        form.setFieldsValue({unit: e});
    };

    const onReelChanges  = (event) => {
        setRewinderReelChanged(true);
        if(event.target.value === ""){
          form.setFieldsValue({ planned_weight: 0 });
          setRewinderReelChanged(false);
        } else{
          form.setFieldsValue({no_of_reel_sheet: event.target.value});
        }
    };

    const onUpperTolChange = (e) => {
      setDefaultUpperTol(e.target.value);
      form.setFieldsValue({upper_tolerance: e.target.value});
      if(plannedWeight && form.getFieldValue("upper_tolerance")){
        let upperTol = (plannedWeight * (100 + parseFloat(form.getFieldValue("upper_tolerance")))) /100;
        setUpperTolerance(parseFloat(upperTol).toFixed(3));
      } else{
        setUpperTolerance(0.000);
      }
    };
  
    const onLowerTolChange = (e) => {
      setDefaultLowerTol(e.target.value);
      form.setFieldsValue({lower_tolerance: e.target.value});
      if(plannedWeight && form.getFieldValue("lower_tolerance")){
        let lowerTol = (plannedWeight * (100 - parseFloat(form.getFieldValue("lower_tolerance")))) /100 ;
        setLowerTolerance(parseFloat(lowerTol).toFixed(3));
      } else{
        setLowerTolerance(0.000);
      }
    };

    const calculateUpperTolerance = () => {
      if(plannedWeight && form.getFieldValue("upper_tolerance")){
        let upperTol = (plannedWeight * (100 + parseFloat(form.getFieldValue("upper_tolerance")))) /100;
        setUpperTolerance(parseFloat(upperTol).toFixed(3));
      } else{
        setUpperTolerance(0.000);
      }
    };
  
    const calculateLowerTolerance = () => {
      if(plannedWeight && form.getFieldValue("lower_tolerance")){
        let lowerTol = (plannedWeight * (100 - parseFloat(form.getFieldValue("lower_tolerance")))) /100 ;
        setLowerTolerance(parseFloat(lowerTol).toFixed(3));
      } else{
        setLowerTolerance(0.000);
      }
    };

    const onChangeCollpase = (key) => {
      // console.log(key);
    };

    const handlePrice = (e) => {
      form.setFieldsValue({price: e.target.value});
      setPrice(e.target.value);
    };

    const netPrice = () => {
      let plannedWtConversion;
      if(unitPlaceholder?.toLowerCase() !== priceUnit?.toLowerCase()){
        let unitToTonneConv = plannedWeight * weight_Unit_Conversions[unitPlaceholder];
        plannedWtConversion  = unitToTonneConv * conversionFactorTonneToUnits[priceUnit];
      } else{
        plannedWtConversion  = plannedWeight;
      }

      const netPrice = parseFloat(price) * parseFloat(plannedWtConversion)
        ? parseFloat(price) * parseFloat(plannedWtConversion)
        : "";
      if (netPrice){
        form.setFieldsValue({ net_price: parseFloat(netPrice).toFixed(3) });
      } else{
        form.setFieldsValue({ net_price: "" });
      }
    };

    const onChangeWeightUnit = (e) => {
      setUnitPlaceholder(e);
      setWeightUnitChange(e);
      form.setFieldsValue({weightUnit: e});
    };

    const onChangeHandlerBox = (e) => {
      setCheckedBox(e.target.checked);
      !e.target.checked
        ? form.setFieldsValue({
          delivery_address_line_1: "",
          delivery_address_line_2: "",
          delivery_state: "",
          delivery_city: "",
          zip_code: "",
          delivery_country: "",
        })
        : form.setFieldsValue({
          delivery_address_line_1: orderDetails.delivery_address_line_1,
          delivery_address_line_2: orderDetails.delivery_address_line_2,
          delivery_state: orderDetails.delivery_state,
          delivery_city: orderDetails.delivery_city,
          zip_code: orderDetails.delivery_pincode,
          delivery_country: orderDetails.delivery_country,
        });
    };
  
    const handleProvinceChange = (value) => {
      setCities(State.getStatesOfCountry(value));
      form.setFieldsValue({
        delivery_state: State.getStatesOfCountry(value)[0]?.name,
      });
    };
  
    const onSecondCityChange = (value) => {
      // setSecondCity(value);
    };

    const OnCountryToggleSelect =()=>{
      setCountryDropdown((prevState) => !prevState
    )
    }
  
    const OnStateToggleSelect =()=>{
      setStateDropdown((prevState) => !prevState
    )
    }

    const editOrder = async (event) => {
      const body = {
        product_spec: event.product_spec,
        type: event.type.toLowerCase(),
        grain: event.grain ? event.grain.split(" ")[0].toLowerCase() : null,
        length: event.length,
        width: event.width,
        delivery_address_line_1: event.delivery_address_line_1,
        delivery_address_line_2: event.delivery_address_line_2,
        delivery_city: event.delivery_city,
        delivery_state: event.delivery_state,
        delivery_country: Country.getCountryByCode(event.delivery_country)
          ? Country.getCountryByCode(event.delivery_country).name
          : event.delivery_country,
        delivery_pincode: event.zip_code,
        quoted_price: event.price ? event.price : 0,
        net_price: event.net_price ? event.net_price : 0,
        reel_od: event.reel_od ? parseFloat(event.reel_od) : 0,
        core_id: event.core_od ? parseFloat(event.core_od) : 0,
        remarks: event.remarks,
        currency: event.currency ? event.currency : "",
        delivery_date: event.delivery_date ? new Date(event.delivery_date).getFullYear() + "-" + ((event.delivery_date && ((new Date(event.delivery_date).getMonth() + 1) <= 9)) ? (("0") + parseInt(new Date(event.delivery_date).getMonth() + 1)) : parseInt(new Date(event.delivery_date).getMonth() + 1)) + "-" + new Date(event.delivery_date).getDate() + "T00:00:00Z" : "",
        product: event.product_code,
        planned_weight: event.planned_weight ? parseFloat(event.planned_weight) : 0,
        use_po_address: checkedBox ? true : false,
        reel_diameter: rewinderDia? "multiple" : "single",
        quantity_type: orderQuantity === "weight" ? "weight" : "reel_sheet",
        ...(orderQuantity === "weight" && { weight: event.weight }),
        ...(orderQuantity !== "weight" && {
          no_of_reel_sheet: event.quantity ? event.quantity : 0,
        }),
        quantity: event.no_of_reel_sheet ? event.no_of_reel_sheet : 0,
        ...(event.type.toLowerCase() === "sheet" && {
          rotation: grainChanges,
          grain_mixing: mixedGrain,
          upper_tolerance: form.getFieldValue("upper_tolerance") ? form.getFieldValue("upper_tolerance") : 0,
          lower_tolerance: form.getFieldValue("lower_tolerance") ? form.getFieldValue("lower_tolerance") : 0,
          calculated_upper_tolerance: upperTolerance? upperTolerance : 0,
          calculated_lower_tolerance: lowerTolerance? lowerTolerance : 0
         }),
         units: {
          weight: event.weightUnit,
          ...event.type.toLowerCase() === "sheet" && {length: event.widthUnit},
          width: event.widthUnit,
          planned_weight: unitPlaceholder,
          ...event.type.toLowerCase() === "sheet" &&  {calculated_upper_tolerance: unitPlaceholder},
          ...event.type.toLowerCase() === "sheet" &&  {calculated_lower_tolerance: unitPlaceholder},
          core_id: event.unit,
          reel_od: event.unit,
          quoted_price: event.currency,
          net_price: event.currency,
          per_weight_unit: priceUnit,
        }
      };
      // console.log(body);
      updateOrder(props?.selectedOrderNo, body, props.type)
        .then((response) => {
          if (props?.selectedState === "Open" || props?.isEditFromIncompleteOrder) {
            props?.rendering(true);
            props?.toasterAction({
              error: response.error,
              msg: `Changes are successfully saved to Order ${props?.selectedOrderNo}`,
            });
            props.showToaster();
          }
        })
        .catch((error) => {
          console.log("Error in updating order:", error?.response?.data);
          props.toasterAction({
            error: error.response.error,
            msg: error.response.msg,
          });
          props.showToaster();
          // props.onClose();
        });
    };

    const handleSave = (event) => {
      editOrder(event).then((res) => {
          setMixedGrain(false);
          setGrainChanges(false);
          setRewinderDia(false);
          setCoreOdValidationError(false);
          setRewinderReelChanged(false);
          setIsDefaultTolEnabled(false);
          setFirstLoad(false);
          setGrain("");
          setWidth("");
          setLength("");
          setWeight("");
          setQuantity("");
          setCoreod("");
          setReelod("");
          setPrice("");
          setWidthUnitChange("");
          setReelCoreUnitChange("");
          setDefaultLowerTol("");
          setDefaultUpperTol("");
          setUpperTolerance("");
          setLowerTolerance("");
          setPlannedWeight(0);
          setPlannedReels(0);
          setSettings([]);
          setOrderQuantity("weight");
          props.onClose();
          setWeightUnitChange("");
          setUnitPlaceholder("");
          setMeasurementData();
          setWeightUnitList([]);
          setDimesionUnitList([]);
          setReiwnderDimUnitList([]);
          setCurrencyUnitData([]);
          setPriceUnit("");
      });
  };

    const onFinish = (e) => {
      e = { ...e,
        width: e.width ? e.width : 0,
        reel_od: e.reel_od ? e.reel_od : 0,
        core_od: e.core_od ? e.core_od : 0,
       }
       if(e.type === "sheet") {
         e = { ...e, length : e.length}
       }
     
       if (!coreOdValidationError) {
         ((props?.selectedState === "Open") || ((props?.isEditFromIncompleteOrder && props?.type === "deckleRecord") || 
         (props?.isEditFromIncompleteOrder && !orderMangtSettings?.data?.edit_after_approval?.value && props?.type === "orderRecord"))) ? handleSave(e) : handleApproval(e);
       }
    };

    const cancelChanges = () => {
        form.resetFields();
        props.onCloseGrade();
        setRewinderDia(false);
        setMixedGrain(false);
        setGrainChanges(false);
        setCoreOdValidationError(false);
        setRewinderReelChanged(false);
        setIsDefaultTolEnabled(false);
        setFirstLoad(false);
        setWidth("");
        setGrain("");
        setLength("");        
        setWeight("");
        setQuantity("");
        setCoreod("");
        setReelod("");
        setPrice("");
        setCoreod("");
        setReelod("");
        setWidthUnitChange("");
        setReelCoreUnitChange("");
        setDefaultLowerTol("");
        setDefaultUpperTol("");
        setUpperTolerance("");
        setLowerTolerance("");
        setPlannedWeight(0);
        setPlannedReels(0);
        setSettings([]);
        setOrderQuantity("weight");
        setWeightUnitChange("");
        setPriceUnit("");
        setUnitPlaceholder("");
        setMeasurementData();
        setWeightUnitList([]);
        setDimesionUnitList([]);
        setReiwnderDimUnitList([]);
        setCurrencyUnitData([]);
    };

    const handleApproval = (event) => {
      setIsVisibleApprovalModal({
        visible: true,
        data: event,
      });
    };

    const approvalModalClose = () => {
      setIsVisibleApprovalModal({
        ...isVisibleApprovalModal,
        visible: false,
      });
    };

    const approvalModalConfirm = (data) => {
    setIsVisibleApprovalModal({
      ...isVisibleApprovalModal,
      visible: false,
    });
    const body = {
      state: "pending",
      comment: "your order is sent for Approval",
    };
    editOrder(data).then(() => {
      props.onClose();
      rejectOrApproveOrder(props.selectedOrderNo, body)
        .then((response) => {
          // Toaster for sending approval
          props.rendering(true);
          props.toasterAction({
            error: response.error,
            msg: `Order ${props.selectedOrderNo} is successfully sent for approval`,
          });
          props.showToaster();
        setPlannedReels(0);
        setPlannedWeight(0)
        setRewinderReelChanged(false);
        setFirstLoad(false);
        })
        .catch((error) => {
          console.log("Error in sending to pending state:", error);
        setPlannedReels(0);
        setPlannedWeight(0);
        setRewinderReelChanged(false);
        setRewinderDia(false);
        setFirstLoad(false);
        });
    });
    };

    //calculations
    const rewinderReelsCal = () => {
      setPlannedReels(0);
      let size;
      if(form.getFieldValue("type") === "reel"){
        size = widthValue;
      } else{
        size = (grainValue === "Long Grain" || grainValue === "long" || grainValue === "long grain") ?
        ((parseFloat(widthValue) > parseFloat(lengthValue)) ? lengthValue : widthValue) :
        ((parseFloat(lengthValue) > parseFloat(widthValue)) ? lengthValue : widthValue);
      }
      if ((form.getFieldValue("type") === "reel" || details?.type === "reel") && orderQuantity === "reel" && quantityValue) {
        form.setFieldsValue({no_of_reel_sheet: quantityValue});
        setRewinderReelChanged(true);
        setPlannedReels(quantityValue);
      } else{
        if (weightValue || quantityValue) {
          if (
            size &&
            coreOD &&
            reelOD &&
            productData?.bulk &&
            size !== 0 &&
            coreOD !== reelOD
          ) {
            let orderDimConversion = orderDim_Rewinder_Unit_Conversion[widthUnitChange];
            let rewinderUnitConversion = orderDim_Rewinder_Unit_Conversion[reelCoreUnitChange];
            let weightUnitConversion = weight_Unit_Conversions[weightUnitChange];
            calculatePlannedReels(
              size * orderDimConversion,
              lengthValue * orderDimConversion,
              widthValue * orderDimConversion,
              weightValue * weightUnitConversion,
              productData?.bulk,
              productData?.gsm,
              coreOD * rewinderUnitConversion,
              reelOD * rewinderUnitConversion
            );
          } else{
            setPlannedReels(0);
            form.setFieldsValue({no_of_reel_sheet: 0});
            setRewinderReelChanged(true);
          }
        }
      }
    }

    const calculatePlannedReels = (
      size,
      length,
      width,
      weight,
      bulk,
      gsm,
      coreOd,
      reelOd
    ) => {
      setPlannedReels(0);
        const value = orderQuantity === "weight"
            ? (parseFloat(weight) * 1000 * 1000 * parseFloat(bulk) * 4) /
              (3.14 * parseFloat(size) * (Math.pow(parseFloat(reelOd), 2) - Math.pow(parseFloat(coreOd), 2)))
            : (parseFloat(length) * parseFloat(width) * parseFloat(quantityValue) * parseFloat(gsm) * parseFloat(bulk) * 4) /
              (3.14 * parseFloat(size) * (Math.pow(parseFloat(reelOd), 2) - Math.pow(parseFloat(coreOd), 2)) * 10000);
        form.setFieldsValue({ no_of_reel_sheet: Math.round(value.toFixed(2)) ? Math.round((value * 1).toFixed(3)) : 1 });
        setRewinderReelChanged(true);
        setPlannedReels((value * 1).toFixed(3));
    };

    const plannedWeightCal = () => {
      setPlannedWeight(0);
      let reels = form.getFieldValue("no_of_reel_sheet");
      let size;
      if (form.getFieldValue("type") === "reel"){
        size = widthValue;
      } else{
        size = (grainValue === "Long Grain" || grainValue === "long" || grainValue === "long grain") ?
        ((parseFloat(widthValue) > parseFloat(lengthValue)) ? lengthValue : widthValue) :
        ((parseFloat(lengthValue) > parseFloat(widthValue)) ? lengthValue : widthValue);
      }
      if (size && coreOD && reelOD) {
        let orderDimConversion = orderDim_Rewinder_Unit_Conversion[widthUnitChange];
        let rewinderUnitConversion = orderDim_Rewinder_Unit_Conversion[reelCoreUnitChange];
        calculatePlannedWeight(
          size * orderDimConversion,
          productData?.bulk,
          reelOD * rewinderUnitConversion,
          coreOD * rewinderUnitConversion,
          reels
        );
      }
      else{
        if(form.getFieldValue("type") === "reel"){
          form.setFieldsValue({planned_weight: 0});
        } else {
          if(form.getFieldValue("type") === "sheet" && orderQuantity === "weight"){
            if(weightValue){
              setPlannedWeight(parseFloat(weightValue)?.toFixed(2));
              form.setFieldsValue({planned_weight: parseFloat(weightValue)?.toFixed(2)});
            } else{
              form.setFieldsValue({planned_weight: 0});
            }
          } else{
            let divisorDimension = orderDim_Rewinder_Unit_Conversion[widthUnitChange];
            let length_Value = lengthValue * divisorDimension;
            let width_Value = widthValue * divisorDimension;
            const value = ((length_Value * width_Value * quantityValue * productData?.gsm) / (10000 * 1000000));
            let weightUnitValue = form.getFieldValue("weightUnit");
            let plannedWeightValue =  value * conversionFactorTonneToUnits[weightUnitValue];
            setPlannedWeight(plannedWeightValue ? plannedWeightValue?.toFixed(3) : 0);
            form.setFieldsValue({planned_weight: plannedWeightValue ? plannedWeightValue.toFixed(3) : 0});
            // setPlannedWeight(value?.toFixed(2));
            // form.setFieldsValue({planned_weight: value?.toFixed(2)});
          }
        }
      }
    }

    const calculatePlannedWeight = (size, bulk, reelOd, coreOd, plannedReels) => {
      if(parseFloat(productData?.bulk)){
        const value = (3.14 * parseFloat(size) * (Math.pow(parseFloat(reelOd), 2) - Math.pow(parseFloat(coreOd), 2)) *
          parseFloat(plannedReels)) / (1000 * 1000 * parseFloat(bulk) * 4);
          let weightUnitValue;
          if(orderQuantity === "reel" || orderQuantity === "sheet"){
            weightUnitValue = measurementData?.data.units_management.weight.default;
          }else{
            weightUnitValue = form.getFieldValue("weightUnit");
          }
          let plannedWeightValue =  value * conversionFactorTonneToUnits[weightUnitValue];
          setPlannedWeight(plannedWeightValue ? plannedWeightValue?.toFixed(3) : 0);
          form.setFieldsValue({planned_weight: plannedWeightValue ? plannedWeightValue.toFixed(3) : 0});
        // form.setFieldsValue({ planned_weight: value.toFixed(3) });
        // setPlannedWeight(value.toFixed(3));
      } else{
        form.setFieldsValue({ planned_weight: 0.000 });
        setPlannedWeight(0.000);
      }
    };

    useEffect(() => {
        (async ()=>{
        getProductsData({ status: "active" })
          .then((response) => {
            setProducts(response);
          })
          .catch((error) => {
            console.log("Error in fetching products list:", error);
          });
    
        getMachineGradeSelect()
          .then((response) => {
            const reelValue = response.data.data.settings.order_types[0].value;
            const sheetValue = response.data.data.settings.order_types[1].value;
            setIsDefaultTolEnabled(response.data.data.settings.order_types[2].value);
            setSettings(response.data.data.settings.order_types);
            const typeData =
              reelValue && sheetValue
                ? [
                  { label: "Reel", value: "reel" },
                  { label: "Sheet", value: "sheet" },
                ]
                : reelValue
                  ? [{ label: "Reel", value: "reel" }]
                  : sheetValue
                    ? [{ label: "Sheet", value: "sheet" }]
                    : [];
            setOrderTypes(typeData);
          })
          .catch((error) => console.log(error));

          try{
            const unitData = await getUnitData();
            if(!unitData.error){
              setMeasurementData(unitData);
              setReiwnderDimUnitList(unitData.data.units_management.length.data);
              setDimesionUnitList(unitData.data.units_management.length.data);
              setWeightUnitList(unitData.data.units_management.weight.data);
              let currencyData = currency_List?.filter(item => (unitData.data.units_management.currency.data.includes(item.code)));
              setCurrencyUnitData(currencyData);
    
          //     setUnitPlaceholder(unitData.data.units_management.weight.default);
            }
          } catch(err){
            console.log(err);
          }

          try {
            const response = await getReelCoreValues();
            if (!response.error) {
              setReelCoreData(response);
              const reelData = response.reel_data.map((item) => {
                return {
                  value : item[0]+ " " + item[1]
                }
              })
              const coreData = response.core_data.map((item) => {
                return {
                  value : item[0]+ " " + item[1]
                }
              })
              setCoreValues(coreData);
              setReelvalues(reelData);
            }
          } catch (error) {
            console.log(error);
          }
          let orderMangtSettings = await getWorkflowSettings("order_management");
          setOrderMangtSettings(orderMangtSettings);
          let deckleMangtSettings = await getWorkflowSettings("deckle_management");
          setDeckleMangtSettings(deckleMangtSettings);
        })();
    }, []);
    
    useEffect(() => {
        if (props?.selectedOrderNo) {
          if (props.type == 'orderRecord') {
          getAllOrdersListByOrderno(props.selectedOrderNo)
            .then((response) => {
              setOrderDetails(response.data);
            })
            .catch((error) => {
              console.log(error);
            });
          }
          else {
            getAllDeckleMatchingOrdersListByOrderno(props?.selectedOrderNo)
            .then((response) => {
              setOrderDetails(response.data);
            })
            .catch((error) => {
              console.log(error);
            });
          }
        }
        return () => setOrderDetails();
    }, [props]);

    useEffect(() => {
        form.resetFields();
        if (orderDetails) {
            orderDetails.use_po_address ? setCheckedBox(true) : setCheckedBox(false);

            setOrderQuantityTab([
                { label: "Weight", value: "weight" },
                {
                  label: orderDetails?.type
                    ? `${capitalize(orderDetails?.type)}s`
                    : "Reels/Sheets",
                  value: orderDetails?.type,
                },
            ]);
    
            if(orderDetails?.reel_diameter === "multiple"){
                setRewinderDia(true);
            }

            setMixedGrain(orderDetails?.grain_mixing);
            setGrainChanges(orderDetails?.rotation);
            setPriceUnit(orderDetails?.units?.per_weight_unit);
            if(orderDetails?.quantity_type === "weight") {
              setOrderQuantity("weight");
              setUnitPlaceholder(orderDetails?.units.weight);
            } else{ 
              setOrderQuantity(orderDetails?.type);
              setUnitPlaceholder(measurementData?.data?.units_management?.weight.default);
            }
            orderDetails?.grain?.toLowerCase() === "long" ? setGrain("Long Grain") : setGrain("Short Grain");
            if(form.getFieldValue("type") !== "reel" && orderDetails?.type === "sheet"){
              form.setFieldsValue({upper_tolerance: orderDetails?.upper_tolerance});
              form.setFieldsValue({lower_tolerance: orderDetails?.lower_tolerance});
              setDefaultUpperTol(orderDetails?.upper_tolerance);
              setDefaultLowerTol(orderDetails?.lower_tolerance);
              setUpperTolerance(orderDetails?.calculated_upper_tolerance);
              setLowerTolerance(orderDetails?.calculated_lower_tolerance);
            }
            
            setDetails({
                orderno: orderDetails.number,
                pono: orderDetails.po,
                productSpec: orderDetails.product_spec,
                type: orderDetails.type,
                grain: `${orderDetails.grain}`.toLowerCase(),
                length: orderDetails.length,
                width: orderDetails.width,
                weight: orderDetails.weight,
                quantity: orderDetails.type === "reel" &&
                orderDetails.quantity_type === "reel_sheet" ? parseInt(orderDetails.no_of_reel_sheet) : orderDetails.quantity ? orderDetails.quantity : 0,
                core_od: orderDetails.core_id ? orderDetails.core_id : "",
                reel_od: orderDetails.reel_od ? orderDetails.reel_od : "",
                price: parseFloat(orderDetails.quoted_price) ? parseFloat(orderDetails?.quoted_price).toFixed(3) : "",
                net_price: parseFloat(orderDetails?.net_price) ? parseFloat(orderDetails?.net_price).toFixed(3) : "",
                currency: orderDetails.currency,
                delivery_date: moment(orderDetails.delivery_date).format("DD MM YYYY"),
                delivery_address_line_1: orderDetails.delivery_address_line_1,
                delivery_address_line_2: orderDetails.delivery_address_line_2,
                delivery_state: orderDetails.delivery_state,
                delivery_city: orderDetails.delivery_city,
                delivery_pincode: orderDetails.delivery_pincode,
                delivery_country: orderDetails.delivery_country,
                remarks: orderDetails.remarks,
                priority: orderDetails.forced,
                state: orderDetails.state,
                product_code: orderDetails.product,
                quantityType: orderDetails.quantity_type,
                plannedWeight: orderDetails?.planned_weight ? parseFloat(orderDetails.planned_weight).toFixed(3) : 0,
                no_of_reel_sheet: parseInt(orderDetails.no_of_reel_sheet),
                comment: orderDetails.comments.length
                  ? orderDetails.comments[orderDetails.comments.length - 1]
                  : "Approver remarks does not have any data",
                reel_diameter: orderDetails?.reel_diameter,
                calculated_lower_tolerance : orderDetails?.calculated_lower_tolerance,
                calculated_upper_tolerance: orderDetails?.calculated_upper_tolerance,
                grain_mixing: orderDetails?.grain_mixing,
                rotation: orderDetails?.rotation,
                upper_tolerance: orderDetails?.upper_tolerance,
                lower_tolerance: orderDetails?.lower_tolerance,
                units: orderDetails?.units,
            });

            orderDetails?.po && getPosDetails(orderDetails?.po).then((response) => {
               setPoDetails(response?.data);
            }).catch((error) => {
                console.log(error);
            });

            // orderDetails?.product && await getProductDetails(orderDetails?.product).then((resp) => {
            //   setProductData({
            //     bulk: `${resp?.data?.bulk}`,
            //     gsm: `${resp?.data?.gsm}`,
            //   });
            // }).catch((error) => {
            //   console.log(error);
            // });
        }
        return () => {
        setDetails();
        setPoDetails();
        // setProductData();
        };
    },[orderDetails]);

    useEffect(() => {
      (async () => {
      if (details) {
        setOrderQuantity(
          details?.quantityType === "weight"
            ? "weight"
            : details?.type
        );
        setWidthUnitChange(details.units.width);
        setReelCoreUnitChange(details.units.core_id);
        setWeightUnitChange(details?.quantityType === "weight" ? details.units.weight : "");
        // if (
        //   reelCoreData &&
        //   reelCoreData?.default_core_id &&
        //   reelCoreData?.default_reel_od && details?.type === 'reel'
        // ) {
        //  await validateDefaultCoreOdReelOd(reelCoreData?.default_core_id, reelCoreData?.default_reel_od);
        // }
        // else{
          if(details.type === "reel"){
            form.setFieldsValue({reel_od: `${details?.reel_od ? details?.reel_od?.toFixed(3) : ""}`, core_od:`${details?.core_od ? details?.core_od?.toFixed(3) : ""}`});
          } else{
            form.setFieldsValue({reel_od: `${details?.reel_od}` ,core_od:`${details?.core_od}`});
          }
          setPlannedWeight(details?.plannedWeight);
          
        // }
        await getProductDetails(details?.product_code)
          .then((response) => {
            setProductData({
              bulk: `${response?.data?.bulk}`,
              gsm: `${response?.data?.gsm}`,
            });
            // setPriceUnit(response.data.units.per_weight_unit);
          })
          .catch((error) => {});
        
          setFirstLoad(true);

      }
    })();
    }, [details]);

    useEffect(() => {
      if(isFirstLoad && details && productData?.gsm){
        if(orderDetails?.type === "sheet"){
          setLength(orderDetails?.length);
          setGrain(orderDetails?.grain?.toLowerCase());
        }
        orderDetails?.width ? setWidth(orderDetails?.width) : setWidth(0);
        if(orderDetails?.type === "reel"){
          let a = form.getFieldValue("unit");
          orderDetails.core_id ? setCoreod(orderDetails?.core_id?.toFixed(3)) : setCoreod(0);
          orderDetails.reel_od ? setReelod(orderDetails?.reel_od?.toFixed(3)) : setReelod(0);
        } else{
          orderDetails.core_id ? setCoreod(orderDetails?.core_id) : setCoreod(0);
          orderDetails.reel_od ? setReelod(orderDetails?.reel_od) : setReelod(0);
        }
        orderDetails?.quantity_type === "weight"? setWeight(orderDetails?.weight) : setWeight(0);
        orderDetails?.quantity_type === "reel_sheet"? setQuantity(orderDetails?.no_of_reel_sheet) : setQuantity(0);
        orderDetails?.quoted_price ? setPrice(orderDetails?.quoted_price) : setPrice(0);
      } else{
        setLength("");
        setGrain("");
        setWidth("");
        setCoreod("");
        setReelod("");
        setWeight("");
        setQuantity("");
      }
    },[isFirstLoad]);

    useEffect(() => {
      if(isRewinderReelChanged){
        plannedWeightCal();
        setRewinderReelChanged(false);
      }
    },[isRewinderReelChanged]);

    useEffect(() => {
      setPlannedWeight(0);
      if(widthValue && (coreOD || form.getFieldValue('core_od')) && (reelOD || form.getFieldValue('reel_od'))){
          rewinderReelsCal();
      } else{
        form.setFieldsValue({no_of_reel_sheet: 0});
        setPlannedReels(0);
      }
      if(!coreOD || !reelOD){
        let type = form.getFieldValue("type") ? form.getFieldValue("type") : details?.type;
        if(type === "sheet" && orderQuantity === "weight"){
          if(weightValue){
            setPlannedWeight(parseFloat(weightValue).toFixed(3));
            form.setFieldsValue({planned_weight: parseFloat(weightValue).toFixed(3)});
          } else{
            form.setFieldsValue({planned_weight: 0});
          }       
        } else{
          let divisorDimension = orderDim_Rewinder_Unit_Conversion[widthUnitChange];
          let length_Value = lengthValue * divisorDimension;
          let width_Value = widthValue * divisorDimension;
          const value = ((length_Value * width_Value * quantityValue * productData?.gsm) / (10000 * 1000000));
          let weightUnitValue = measurementData?.data.units_management.weight.default;
          let plannedWeightValue =  value * conversionFactorTonneToUnits[weightUnitValue];
          setPlannedWeight(plannedWeightValue ? plannedWeightValue?.toFixed(3) : 0);
          form.setFieldsValue({planned_weight: plannedWeightValue ? plannedWeightValue.toFixed(3) : 0});
        }
      }
      },[widthValue,coreOD,reelOD,weightValue,quantityValue,lengthValue,grainValue,widthUnitChange,reelCoreUnitChange,weightUnitChange,productData]);
  
    useEffect(() => {
      netPrice();
      calculateUpperTolerance();
      calculateLowerTolerance();
    }, [price, plannedWeight, unitPlaceholder]);

    return details?.type && orderQuantityTab && reelCoreData? (
      <RightDrawerSidebar
        title={`Order Details - #${details?.orderno}`}
        subtitle=""
        visible={props.visible}
        onClose={() => {
          props.onCloseGrade();
          setMixedGrain(false);
          setGrainChanges(false);
          setRewinderDia(false);
          setCoreOdValidationError(false);
          setRewinderReelChanged(false);
          setIsDefaultTolEnabled(false);
          setFirstLoad(false);
          setGrain("");
          setWidth("");
          setLength("");
          setWeight("");
          setQuantity("");
          setCoreod("");
          setReelod("");
          setPrice("");
          setWidthUnitChange("");
          setReelCoreUnitChange("");
          setDefaultLowerTol("");
          setDefaultUpperTol("");
          setUpperTolerance("");
          setLowerTolerance("");
          setPlannedWeight(0);
          setPlannedReels(0);
          setSettings([]);
          setOrderQuantity("weight");
          setWeightUnitChange("");
          setPriceUnit("");
          setUnitPlaceholder("");
          setMeasurementData();
          setWeightUnitList([]);
          setDimesionUnitList([]);
          setReiwnderDimUnitList([]);
          setCurrencyUnitData([]);
        }}
      >
        <RightDrawerContainer>
          <div className="resetPassForm removePadLeft">
            <DetailFields className="marginBtnP">
              <HaberForm>
                {(details?.priority ||
                  ["rejected", "review", "hold"].includes(details?.state)) && (
                  <div className="drawerFieldAlert">
                    <div className="titleWithText" style={{ marginBottom: 20 }}>
                      {/* Priority Order means need to show this blue alert box */}
                      {details?.priority && (
                        <>
                          <h5
                            style={{
                              paddingTop: 0,
                              paddingBottom: 20,
                            }}
                          >
                            Priority Order
                          </h5>
                          <AlertContainer
                            color="blue"
                            icon={alertBlue}
                            msg="This Order is prioritized by the approver"
                          />
                        </>
                      )}
                      {details?.state !== "open" &&
                        details?.state !== "approved" && (
                          <>
                            <h5
                              style={{
                                paddingTop: 0,
                                paddingBottom: 20,
                              }}
                            >
                              {details?.state === "review"
                                ? "Requested Changes"
                                : details?.state === "rejected"
                                ? "Reason for Rejection"
                                : details?.state === "hold"
                                ? "Reason for Holding Order"
                                : ""}
                            </h5>
                            <AlertContainer
                              color={
                                details?.state === "review" ? "yellow" : "red"
                              }
                              icon={
                                details?.state === "review"
                                  ? alertYellow
                                  : alertRed
                              }
                              msg={details?.comment}
                            />
                          </>
                        )}
                    </div>
                  </div>
                )}
                <Form
                  name="basic"
                  autoComplete="off"
                  className="haberLogin haberSignup"
                  style={{ marginTop: "0" }}
                  onFinish={onFinish}
                  form={form}
                >
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Order Number</h5>
                      <p>A unique auto-generated code to identify this order</p>
                    </div>
                    <Form.Item
                      name="pono"
                      rules={[{ required: true }]}
                      className=""
                      initialValue={details?.orderno}
                    >
                      <Input disabled={true} placeholder="Enter Order Number" />
                    </Form.Item>
                  </div>

                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Product Name</h5>
                      <p>Unique name to identify the product</p>
                    </div>
                    <Form.Item
                      name="product_code"
                      rules={[{}]}
                      className="selectForm"
                      initialValue={details?.product_code}
                    >
                      <Select
                        placeholder="Select Product"
                        suffixIcon={
                          isProductDropdownOpen ? (
                            <DropDownSearchDraw />
                          ) : (
                            <DownArrowDraw />
                          )
                        }
                        onBlur={OnProductToggleSelect}
                        onFocus={OnProductToggleSelect}
                        showSearch
                        optionFilterProp="children"
                        onChange={handleProduct}
                        disabled={
                          (props.isEditFromIncompleteOrder &&
                            props.type === "deckleRecord") ||
                          (props.isEditFromIncompleteOrder &&
                            props.type === "orderRecord" &&
                            !orderMangtSettings?.data?.edit_after_approval
                              ?.value)
                        }
                      >
                        {products?.map((product) => (
                          <Option key={product.code}>
                            {product.code} - {product.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>

                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Product Specifications</h5>
                      <p>Combination of Grade/GSM/BF/Quality/Moisture</p>
                    </div>
                    <Form.Item
                      name="product_spec"
                      rules={[{}]}
                      className="selectForm"
                      initialValue={details?.productSpec}
                    >
                      <Input placeholder="Prouct Specification" disabled />
                    </Form.Item>
                  </div>

                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Order type</h5>
                      <p>The order can be of reel or sheet type</p>
                    </div>
                    <Form.Item
                      name="type"
                      rules={[{ required: true }]}
                      className="selectForm"
                      initialValue={details?.type}
                    >
                      <Select
                        placeholder="Select"
                        suffixIcon={<DownArrowDraw />}
                        onChange={handleType}
                        disabled={
                          (props.isEditFromIncompleteOrder &&
                            props.type === "deckleRecord") ||
                          (props.isEditFromIncompleteOrder &&
                            props.type === "orderRecord" &&
                            !orderMangtSettings?.data?.edit_after_approval
                              ?.value)
                        } // disabled={(props.isEditFromIncompleteOrder && props.type != "orderRecord") || (!orderMangtSettings?.data?.edit_after_approval?.value)}
                      >
                        {orderTypes?.map((orderType) => (
                          <Option key={orderType.value}>
                            {orderType.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>

                  {form.getFieldValue("type") !== "reel" && (
                    <div className="drawerField">
                      <div className="titleWithText">
                        <h5>Grain</h5>
                        <p>The order can be of long or short grain</p>
                      </div>
                      <Form.Item
                        name="grain"
                        rules={[{ required: true }]}
                        className="selectForm"
                        initialValue={
                          details?.grain && details?.grain !== "null"
                            ? capitalize(details?.grain)
                            : ""
                        }
                        style={{ marginBottom: 4 }}
                        disabled={
                          !grainChanges && props?.type === "deckleRecord"
                        }
                      >
                        <Select
                          placeholder={"Select"}
                          suffixIcon={<DownArrowDraw />}
                          onChange={(e) => {
                            onGrainChange(e);
                          }}
                        >
                          {grainTypeData.map((grainType) => (
                            <Option key={grainType}>{grainType}</Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <div className="italicsTitleWithText">
                        <p>
                          {grainValue === "Long Grain"
                            ? "The shorter side will be matched in deckle matching"
                            : grainValue === "Short Grain" &&
                              "The longer side will be matched in deckle matching"}
                        </p>
                      </div>
                      <div>
                        <Row className="centerAlign justifyCSBetween">
                          <Col>
                            <Checkbox
                              onChange={mixedGrainHandler}
                              checked={mixedGrain}
                            ></Checkbox>
                            <span
                              style={{
                                marginLeft: "5px",
                                fontSize: "12px",
                                fontWeight: "500",
                                fontSize: "12px",
                                fontFamily: "var(--sf-pro-text)",
                                color: "var(--color-text-title)",
                                lineHeight: "20px",
                              }}
                            >
                              Allow mixed grain for this order
                            </span>
                          </Col>
                        </Row>
                      </div>
                      <div style={{ marginBottom: "10px" }}>
                        <Row className="centerAlign justifyCSBetween">
                          <Col>
                            <Checkbox
                              onChange={grainChangesHandler}
                              checked={grainChanges}
                            ></Checkbox>
                            <span
                              style={{
                                marginLeft: "5px",
                                fontSize: "12px",
                                fontWeight: "500",
                                fontSize: "12px",
                                fontFamily: "var(--sf-pro-text)",
                                color: "var(--color-text-title)",
                                lineHeight: "20px",
                              }}
                            >
                              Allow grain changes for this order
                            </span>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )}

                  <div className="drawerField removeStar">
                    <div className="titleWithText">
                      <h5>Order Dimension</h5>
                      <p>
                        {form.getFieldValue("type") === "reel" ? (
                          <>The width of the order</>
                        ) : (
                          <>The width and length of the order</>
                        )}
                      </p>
                    </div>
                    <Row className="centerAlign justifyCSBetween">
                      {form.getFieldValue("type") !== "reel" && (
                        <Col span={8}>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              label="Length"
                              name="length"
                              rules={[
                                {
                                  required:
                                    form.getFieldValue("type") !== "reel"
                                      ? true
                                      : false,
                                  message: "This field is required",
                                },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                                  message:
                                    "Upto 2 decimal point values is accepted",
                                },
                                {
                                  pattern: new RegExp(
                                    /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                  ),
                                  message:
                                    "Length should be a number greater than zero",
                                },
                              ]}
                              className="dBlock"
                              initialValue={details?.length}
                            >
                              <Input
                                placeholder="Length"
                                onChange={(e) => {
                                  onLengthChange(e);
                                }}
                                disabled={
                                  (props?.isEditFromIncompleteOrder &&
                                    props?.type === "deckleRecord") ||
                                  (props?.isEditFromIncompleteOrder &&
                                    props?.type === "orderRecord" &&
                                    !orderMangtSettings?.data
                                      ?.edit_after_approval?.value)
                                }
                                // disabled={(props.isEditFromIncompleteOrder && props.type != "orderRecord") || (!orderMangtSettings?.data?.edit_after_approval?.value)}
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      )}
                      <Col
                        span={form.getFieldValue("type") !== "reel" ? 8 : 16}
                      >
                        <div className="boxFormType">
                          <Form.Item
                            label="Width"
                            name="width"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                                message:
                                  "Upto 2 decimal point values is accepted",
                              },
                              {
                                pattern: new RegExp(
                                  /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                ),
                                message:
                                  "Width should be a number greater than zero",
                              },
                            ]}
                            className="dBlock"
                            initialValue={details?.width}
                          >
                            <Input
                              placeholder="Width"
                              onChange={(e) => {
                                onWidthChange(e);
                              }}
                              disabled={
                                (props.isEditFromIncompleteOrder &&
                                  props.type === "deckleRecord") ||
                                (props.isEditFromIncompleteOrder &&
                                  props.type === "orderRecord" &&
                                  !orderMangtSettings?.data?.edit_after_approval
                                    ?.value)
                              }
                              // disabled={(props.isEditFromIncompleteOrder && props.type != "orderRecord") || (!orderMangtSettings?.data?.edit_after_approval?.value)}
                            />
                          </Form.Item>
                        </div>
                      </Col>
                      <Col span={7}>
                        <div className="boxFormType unitSelect">
                          <Form.Item
                            label="Unit"
                            name="widthUnit"
                            rules={[{ required: true }]}
                            className="dBlock"
                            initialValue={details.units.width}
                          >
                            <Select
                              placeholder="Unit"
                              suffixIcon={<DownArrowDraw />}
                              disabled={
                                (props.isEditFromIncompleteOrder &&
                                  props.type === "deckleRecord") ||
                                (props.isEditFromIncompleteOrder &&
                                  props.type === "orderRecord" &&
                                  !orderMangtSettings?.data?.edit_after_approval
                                    ?.value)
                              }
                              // disabled={(props.isEditFromIncompleteOrder && props.type != "orderRecord") || (!orderMangtSettings?.data?.edit_after_approval?.value)}
                              onChange={(e) => {
                                onWidthUnitChange(e);
                              }}
                            >
                              {dimesionUnitList?.map((deckleWidth) => (
                                <Option key={deckleWidth} value={deckleWidth}>
                                  {lengthUnit[deckleWidth]?.displayName}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Order Quantity</h5>
                      <p>Order format and quantity</p>
                    </div>
                    <div
                      className="switchRadio twoSwitch"
                      style={{ justifyContent: "center", display: "flex" }}
                    >
                      <Radio.Group
                        options={orderQuantityTab}
                        optionType="button"
                        buttonStyle="solid"
                        value={orderQuantity}
                        onChange={handleQuantityChange}
                        disabled={
                          (props.isEditFromIncompleteOrder &&
                            props.type === "deckleRecord") ||
                          (props.isEditFromIncompleteOrder &&
                            props.type === "orderRecord" &&
                            !orderMangtSettings?.data?.edit_after_approval
                              ?.value)
                        }
                        // disabled={(props.isEditFromIncompleteOrder && props.type != "orderRecord") || (!orderMangtSettings?.data?.edit_after_approval?.value)}
                      />
                    </div>
                    {orderQuantity === "weight" ? (
                      <>
                        <div className="subTitleWithText">
                          <p>Weight of order</p>
                        </div>
                        <div style={{ position: "relative" }}>
                          {/* <Form.Item
                            name="weight"
                            rules={[
                              { required: true },
                              {
                                pattern: new RegExp(/^\d+(\.\d+)?$/),
                                message: "Only decimal characters are allowed",
                              },
                              {
                                pattern: new RegExp(
                                  /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                ),
                                message:
                                  "Weight should be a number greater than zero",
                              },
                            ]}
                            className=""
                            initialValue={parseFloat(details?.weight).toFixed(
                              3
                            )}
                          >
                            <Input
                              placeholder="Enter weight"
                              onChange={handleWeight}
                              disabled={
                                (props.isEditFromIncompleteOrder &&
                                  props.type === "deckleRecord") ||
                                (props.isEditFromIncompleteOrder &&
                                  props.type === "orderRecord" &&
                                  !orderMangtSettings?.data?.edit_after_approval
                                    ?.value)
                              }
                              // disabled={(props.isEditFromIncompleteOrder && props.type != "orderRecord") || (!orderMangtSettings?.data?.edit_after_approval?.value)}
                            />
                          </Form.Item>
                          <span className="nonEditable">Tonnes</span> */}
                          <Row className="centerAlign justifyCSBetween">
                            <Col span={13}>
                              <div className="boxFormType">
                                <Form.Item
                                  // label="Weight"
                                  name="weight"
                                  rules={[
                                    { required: true },
                                    {
                                      pattern: new RegExp(/^\d+(\.\d+)?$/),
                                      message: "Only decimal characters are allowed",
                                    },
                                    {
                                      pattern: new RegExp(
                                        /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                      ),
                                      message:
                                        "Weight should be a number greater than zero",
                                    },
                                  ]}
                                  className="dBlock"
                                  initialValue={parseFloat(details?.weight).toFixed(3)}
                                >
                                  <Input
                                    placeholder="Enter weight"
                                    onChange={handleWeight}
                                    disabled={
                                      (props.isEditFromIncompleteOrder &&
                                        props.type === "deckleRecord") ||
                                      (props.isEditFromIncompleteOrder &&
                                        props.type === "orderRecord" &&
                                        !orderMangtSettings?.data?.edit_after_approval
                                          ?.value)
                                    }
                                  />
                                </Form.Item>
                              </div>
                            </Col>
                            <Col span={10}>
                              <div className="boxFormType ">
                                <Form.Item
                                // label="Unit"
                                name="weightUnit"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                ]}
                                className="dBlock"
                                initialValue={details.units.weight}
                              >
                                <Select
                                  placeholder="Unit"
                                  suffixIcon={<DownArrowDraw />}
                                  onChange={onChangeWeightUnit}
                                >
                                  {weightUnitList?.map((unitItem) => (
                                    <Option key={unitItem} value={unitItem}>
                                      {weightUnit[unitItem]?.displayName}
                                    </Option>
                                  ))}
                                </Select>
                                </Form.Item>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="subTitleWithText">
                          <p>{`Number of ${orderQuantity}s`}</p>
                        </div>
                        {form.getFieldValue("type") === "reel" ? (
                          <Form.Item
                            name="quantity"
                            rules={[
                              { required: true },
                              // {
                              //   pattern: new RegExp(/^[0-9]+$/),
                              //   message: "Only Numeric value is possible",
                              // },
                              {
                                pattern: new RegExp(
                                  /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                ),
                                message:
                                  "Quantity should be a number greater than zero",
                              },
                            ]}
                            className=""
                            initialValue={details?.quantity?.toFixed(3)}
                          >
                            <Input
                              placeholder="Enter quantity"
                              onChange={(e) => {
                                onQuantityChange(e);
                              }}
                              disabled={
                                (props.isEditFromIncompleteOrder &&
                                  props.type === "deckleRecord") ||
                                (props.isEditFromIncompleteOrder &&
                                  props.type === "orderRecord" &&
                                  !orderMangtSettings?.data?.edit_after_approval
                                    ?.value)
                              }
                              // disabled={(props.isEditFromIncompleteOrder && props.type != "orderRecord") || (!orderMangtSettings?.data?.edit_after_approval?.value)}
                            />
                          </Form.Item>
                        ) : (
                          <Form.Item
                            name="quantity"
                            rules={[
                              { required: true },
                              // {
                              //   pattern: new RegExp(/^[0-9]+$/),
                              //   message: "Only Numeric value is possible",
                              // },
                              {
                                pattern: new RegExp(
                                  /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                ),
                                message:
                                  "Quantity should be a number greater than zero",
                              },
                            ]}
                            className=""
                            initialValue={details?.no_of_reel_sheet?.toFixed(3)}
                          >
                            <Input
                              placeholder="Enter quantity"
                              onChange={(e) => {
                                onQuantityChange(e);
                              }}
                              disabled={
                                (props.isEditFromIncompleteOrder &&
                                  props.type === "deckleRecord") ||
                                (props.isEditFromIncompleteOrder &&
                                  props.type === "orderRecord" &&
                                  !orderMangtSettings?.data?.edit_after_approval
                                    ?.value)
                              }
                              // disabled={(props.isEditFromIncompleteOrder && props.type != "orderRecord") || (!orderMangtSettings?.data?.edit_after_approval?.value)}
                            />
                          </Form.Item>
                        )}
                      </>
                    )}
                  </div>

                  <div className="drawerField removeStar">
                    <div
                      className="titleWithText"
                      style={{ marginBottom: "-4px" }}
                    >
                      <h5>Rewinder Dimensions</h5>
                      <p>The outer diameter of the reel and rewinder core</p>
                    </div>
                    <Col span={24}>
                      <Row className="centerAlign justifyCSBetween">
                        <Col>
                          <Checkbox
                            onChange={checkBoxChange}
                            checked={rewinderDia}
                          ></Checkbox>
                          <span
                            style={{
                              marginLeft: "5px",
                              fontSize: "12px",
                              fontWeight: "500",
                              fontSize: "12px",
                              fontFamily: "var(--sf-pro-text)",
                              color: "var(--color-text-title)",
                              lineHeight: "20px",
                            }}
                          >
                            Allow multiple rewinder dia in production
                          </span>
                        </Col>
                      </Row>
                      <Row
                        style={{ marginTop: "8px" }}
                        className="centerAlign  justifyCSBetween"
                      >
                        <Col span={8} className="blockBreak">
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            {form.getFieldValue("type") === "sheet" && (
                              <Form.Item
                                label="Core OD"
                                name="core_od"
                                rules={[
                                  {
                                    pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                    message: "Only Numeric value is possible",
                                  },
                                  {
                                    pattern: new RegExp(
                                      /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                    ),
                                    message:
                                      "Core OD should be a number greater than zero",
                                  },
                                ]}
                                className="dBlock"
                                initialValue={details?.core_od}
                              >
                                <Input
                                  placeholder="For Core OD"
                                  className={
                                    coreOdValidationError
                                      ? "showErrorBorder"
                                      : ""
                                  }
                                  onChange={(e) => {
                                    validateCoreOdReelOd(e, "coreOD");
                                  }}
                                />
                              </Form.Item>
                            )}
                            {form.getFieldValue("type") != "sheet" && (
                              <Form.Item
                                label="Core OD"
                                name="core_od"
                                rules={[
                                  {
                                    pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                    message: "Only Numeric value is possible",
                                  },
                                  {
                                    pattern: new RegExp(
                                      /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                    ),
                                    message:
                                      "Core OD should be a number greater than zero",
                                  },
                                ]}
                                className="dBlock"
                                initialValue={ details?.core_od ? details?.core_od : ""
                                }
                              >
                                <AutoComplete
                                  className={
                                    coreOdValidationError
                                      ? "showErrorBorder"
                                      : ""
                                  }
                                  options={coreValues}
                                  placeholder="For Core OD"
                                  filterOption={(inputValue, option) =>
                                    option.value
                                      .toString()
                                      .indexOf(inputValue) !== -1
                                  }
                                  onChange={(e) => {
                                    validateCoreOdReelOd(e, "coreOD");
                                  }}
                                />
                              </Form.Item>
                            )}
                          </div>
                        </Col>
                        <Col span={8} className="blockBreak">
                          <div className="boxFormType">
                            {form.getFieldValue("type") === "sheet" && (
                              <Form.Item
                                label="Reel OD"
                                name="reel_od"
                                rules={[
                                  {
                                    pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                    message: "Only Numeric value is possible",
                                  },
                                  {
                                    pattern: new RegExp(
                                      /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                    ),
                                    message:
                                      "Reel OD should be a number greater than zero",
                                  },
                                ]}
                                className="dBlock"
                                initialValue={details?.reel_od}
                              >
                                <Input
                                  placeholder="For Reel OD"
                                  className={
                                    coreOdValidationError
                                      ? "showErrorBorder"
                                      : ""
                                  }
                                  onChange={(e) => {
                                    validateCoreOdReelOd(e, "reelOD");
                                  }}
                                />
                              </Form.Item>
                            )}
                            {form.getFieldValue("type") != "sheet" && (
                              <Form.Item
                                label="Reel OD"
                                name="reel_od"
                                rules={[
                                  {
                                    pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                    message: "Only Numeric value is possible",
                                  },
                                  {
                                    pattern: new RegExp(
                                      /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                    ),
                                    message:
                                      "Core OD should be a number greater than zero",
                                  },
                                ]}
                                className="dBlock"
                                initialValue={
                                  details.reel_od ? details.reel_od : ""
                                }
                              >
                                <AutoComplete
                                  placeholder="For Reel OD"
                                  className={
                                    coreOdValidationError
                                      ? "showErrorBorder"
                                      : ""
                                  }
                                  options={reelValues}
                                  filterOption={(inputValue, option) =>
                                    option.value
                                      .toString()
                                      .indexOf(inputValue) !== -1
                                  }
                                  onChange={(e) => {
                                    validateCoreOdReelOd(e, "reelOD");
                                  }}
                                />
                              </Form.Item>
                            )}
                          </div>
                        </Col>
                        <Col span={7} className="blockBreak">
                          <div className="boxFormType unitSelect">
                            <Form.Item
                              label="Unit"
                              name="unit"
                              rules={[{ required: true }]}
                              className="dBlock"
                              initialValue={details.units.core_id}
                            >
                              <Select
                                label="Unit"
                                placeholder="Unit"
                                suffixIcon={<DownArrowDraw />}
                                className="dBlock"
                                onChange={(e) => {
                                  onCoreReelUnitChange(e);
                                }}
                              >
                                {rewinderDimUnitList?.map((deckleWidth) => (
                                  <Option key={deckleWidth} value={deckleWidth}>
                                    {lengthUnit[deckleWidth]?.displayName}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>
                        {coreOdValidationError ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            Reel OD cannot be less than Core OD
                          </span>
                        ) : null}
                      </Row>
                    </Col>
                  </div>

                  {((form.getFieldValue("type") === "sheet" && (form.getFieldValue("reel_od") &&
                      form.getFieldValue("core_od"))) || form.getFieldValue("type") === "reel") && 
                    <div className="drawerField">
                      <div className="titleWithText">
                        <h5>Planned Number of Rewinder Reels</h5>
                        <p>
                          The number of rewinder reels required to fulfill the
                          order
                        </p>
                      </div>
                      <div className="redTitleWithText">
                        {orderQuantity !== "reel" && (
                          <h3>{`Calculated number of reels is ${plannedReels}`}</h3>
                        )}
                        <p>
                          The number of reels specified below will be considered
                          for production
                        </p>
                      </div>

                      {props.selectedState === "Approved" ? (
                        orderQuantity === "weight" ? (
                        <Form.Item
                        name="no_of_reel_sheet"
                        rules={[
                          {
                            pattern: new RegExp(/^[0-9]+$/),
                            message: "Only Numeric value is possible",
                          },
                        ]}
                        className=""
                        initialValue={details?.quantity}
                      >
                        <Input
                          placeholder="Enter the number of reels"
                        //   disabled={!isTouched}
                          onChange={(e) => { onReelChanges(e); }}
                        />
                        </Form.Item>
                        ) : (<Form.Item
                            name="no_of_reel_sheet"
                            rules={[
                              {
                                pattern: new RegExp(/^[0-9]+$/),
                                message: "Only Numeric value is possible",
                              },
                            ]}
                            className=""
                            initialValue={ orderDetails?.type == "reel" ? details?.no_of_reel_sheet : details?.quantity}
                          >
                            <Input
                              placeholder="Enter the number of reels"
                              disabled={orderQuantity === "reel"}
                              onChange={(e) => {onReelChanges(e); }}
                            />
                          </Form.Item>)
                        ) : orderQuantity === "weight" ? (
                          <Form.Item
                            name="no_of_reel_sheet"
                            rules={[
                              {
                                pattern: new RegExp(/^[0-9]+$/),
                                message: "Only Numeric value is possible",
                              },
                            ]}
                            className=""
                            initialValue={details?.quantity}
                          >
                            <Input
                              placeholder="Enter the number of reels"
                              onChange={(e) => {
                                onReelChanges(e);
                              }}
                            />
                          </Form.Item>
                        ) : (
                          <Form.Item
                            name="no_of_reel_sheet"
                            rules={[
                              {
                                pattern: new RegExp(/^[0-9]+$/),
                                message: "Only Numeric value is possible",
                              },
                            ]}
                            className=""
                            initialValue={details.quantity}
                          >
                            <Input
                              placeholder="Enter the number of reels"
                              disabled={orderQuantity === "reel"}
                              onChange={(e) => {
                                onReelChanges(e);
                              }}
                            />
                          </Form.Item>
                        )}
                  </div>}

                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Planned Weight</h5>
                      <p>
                        Calculated weight of order for planned number of reels
                      </p>
                    </div>
                    <div style={{ position: "relative" }}>
                      <Form.Item
                        name="planned_weight"
                        rules={[]}
                        className=""
                        initialValue= {details?.plannedWeight}
                      >
                        <Input disabled />
                      </Form.Item>
                      <span className="nonEditable">{weightUnit[unitPlaceholder]?.displayName}</span>
                    </div>
                     {(form.getFieldValue("type") === "sheet" && isDefaultTolEnabled &&
                     !form.getFieldValue("reel_od") && !form.getFieldValue("core_od")) && 
                        <Collapse 
                          onChange={onChangeCollpase}
                          expandIconPosition="right"
                          bordered={false}
                          style={{backgroundColor: "white", marginTop:"-18px"}}>
                          <Panel
                            header={"Tolerance -" + defaultUpperTol + " to +"+ defaultLowerTol +" %"}
                            style={{ fontStyle: "italic" , marginLeft:"-12px"}}
                            // key="1"
                          >
                          <Row
                              style={{ marginTop: "3px" }}
                              className="centerAlign  justifyCSBetween"
                            >
                              <Col span={8} className="blockBreak">
                                <div className="titleWithText">
                                  <p style={{marginTop:"7px", fontStyle: "initial", fontSize: "12px", fontFamily: "var(--sf-pro-text)",
                                  color: "var(--color-text-title)", lineHeight: "20px", }}>Upper Tolerance </p>
                                </div>
                              </Col>
                              <Col span={8} className="blockBreak">
                                <div
                                  className="boxFormType"
                                  style={{ marginBottom: "0" }}
                                >
                                  <Form.Item
                                    label=""
                                    name="upper_tolerance"
                                    rules={[
                                      {
                                        pattern: new RegExp(/^\d+(\.\d{0,5})?$/),
                                        message: "Only Numeric value is possible",
                                      },
                                      {
                                          required: form.getFieldValue("type") === "sheet" ? true : false,
                                          message: "This field is required",
                                      },
                                    ]}
                                    className="dBlock"
                                    initialValue={orderDetails?.upper_tolerance}
                                  >
                                    <Input
                                      placeholder=""
                                      style={{fontSize:"10px",height:"30px"}}
                                      onChange={(e) => {
                                        onUpperTolChange(e);
                                      }}
                                    />
                                  </Form.Item>
                                  <span className="nonEditable" style={{fontize: "13px", top:"5px"}}>%</span>
                                </div>
                              </Col>
                              <Col span={8} className="blockBreak">
                              <Col span={8} className="blockBreak" style={{maxWidth:"45%", marginLeft:"15px"}}>
                                <div className="titleWithText">
                                  <p style={{fontSize: "12px", fontFamily: "var(--sf-pro-text)",
                                  color: "var(--color-text-title)", lineHeight: "20px",
                                    marginTop:"7px",fontStyle: "initial", width:"104px"}}>{upperTolerance+ " "} {weightUnit[unitPlaceholder]?.displayName}</p>
                                </div>
                              </Col>
                              </Col>
                          </Row>

                           <Row
                              style={{ marginTop: "0px" }}
                              className="centerAlign  justifyCSBetween"
                            >
                              <Col span={8} className="blockBreak">
                                <div className="titleWithText">
                                  <p style={{marginTop:"7px", fontStyle: "initial", fontSize: "12px", fontFamily: "var(--sf-pro-text)",
                                  color: "var(--color-text-title)", lineHeight: "20px", }}>Lower Tolerance </p>
                                </div>
                              </Col>
                              <Col span={8} className="blockBreak">
                                <div
                                  className="boxFormType"
                                  style={{ marginBottom: "0" }}
                                >
                                  <Form.Item
                                    label=""
                                    name="lower_tolerance"
                                    rules={[
                                      {
                                        pattern: new RegExp(/^\d+(\.\d{0,5})?$/),
                                        message: "Only Numeric value is possible",
                                      },
                                      {
                                          required: form.getFieldValue("type") === "sheet" ? true : false,
                                          message: "This field is required",
                                      },
                                    ]}
                                    className="dBlock"
                                    initialValue={orderDetails?.lower_tolerance}
                                  >
                                    <Input
                                      placeholder=""
                                      style={{fontSize:"10px", height:"30px"}}
                                      onChange={(e) => {
                                        onLowerTolChange(e);
                                      }}
                                    />
                                  </Form.Item>
                                  <span className="nonEditable" style={{fontize: "13px", top:"5px"}}>%</span>
                                </div>
                              </Col>
                              <Col span={8} className="blockBreak">
                              <Col span={8} className="blockBreak" style={{maxWidth:"45%", marginLeft:"15px"}}>
                                <div className="titleWithText">
                                  <p style={{fontSize: "12px", fontFamily: "var(--sf-pro-text)",
                                  color: "var(--color-text-title)", lineHeight: "20px",
                                    marginTop:"7px",fontStyle: "initial", width:"104px"}}>{lowerTolerance+ " "} {weightUnit[unitPlaceholder]?.displayName}</p>
                                </div>
                              </Col>
                              </Col>
                            </Row>
                          </Panel>
                        </Collapse>
                    } 
                  </div>

                  <div className="drawerField removeStar">
                    <div className="titleWithText">
                      <h5>Price</h5>
                      <p>Price per unit weight of the order</p>
                    </div>
                    <Row className="centerAlign  justifyCSBetween">
                      <Col style={{paddingRight:'5px'}} span={9}>
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <Form.Item
                            label={"Price" + (priceUnit ? (" / " + weightUnit[priceUnit]?.displayName) : "")}
                            name="price"
                            rules={[
                              {
                                pattern: new RegExp(/^\d+(\.\d+)?$/),
                                message: "Only decimal values possible",
                              },
                            ]}
                            className="dBlock"
                            initialValue={details?.price}
                          >
                            <Input
                              placeholder="Price"
                              onChange={handlePrice}
                              disabled={(props.isEditFromIncompleteOrder && props.type === "deckleRecord") || 
                              (props.isEditFromIncompleteOrder && props.type === "orderRecord" && !orderMangtSettings?.data?.edit_after_approval?.value)}                            />
                          </Form.Item>
                        </div>
                      </Col>
                      <Col style={{paddingRight:'5px'}} span={6}>
                        <div className="boxFormType unitSelect">
                          <Form.Item
                            label="Currency"
                            name="currency"
                            rules={[{}]}
                            initialValue={details?.units.net_price}
                            className="dBlock"
                          >
                            <Select
                              placeholder="Currency"
                              suffixIcon={<DownArrowDraw />}
                              disabled={(props.isEditFromIncompleteOrder && props.type === "deckleRecord") || 
                              (props.isEditFromIncompleteOrder && props.type === "orderRecord" && !orderMangtSettings?.data?.edit_after_approval?.value)}
                              // disabled={(props.isEditFromIncompleteOrder && props.type != "orderRecord") || (!orderMangtSettings?.data?.edit_after_approval?.value)}
                              >
                              {currencyUnitData.map((currencyUnit) => (
                              <Option key={currencyUnit.code} value={currencyUnit.code}>
                                <Tooltip title = {currencyUnit.displayName}>
                                      {`${currencyUnit.code}`}
                                      </Tooltip>
                              </Option>
                            ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </Col>
                      <Col span={9}>
                        <div className="boxFormType">
                          <Form.Item
                            label="Net Price"
                            name="net_price"
                            className="dBlock"
                            initialValue={details?.net_price}
                          >
                            <Input placeholder="Net Price" disabled />
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Delivery Date</h5>
                      <p>Date when order needs to be delivered</p>
                    </div>
                    <div className="boxFormType">
                      <DatePickerY>
                        <Form.Item
                          name="delivery_date"
                          rules={[{ required: true }]}
                          initialValue={moment(details?.delivery_date, "DD MM YYYY" )}
                        >
                          <DatePicker format={"DD/MM/YYYY"} />
                        </Form.Item>
                      </DatePickerY>
                    </div>
                  </div>

                  <div className="drawerField" style={{ paddingBottom: "20px" }}>
                    <div className="titleWithText">
                      <h5>Delivery Address</h5>
                      <p>The postal address where order needs to be delivered</p>
                    </div>

                    <Col span={24}>
                      <Row className="centerAlign">
                        <DeliveryaddressSpacing>
                          <Col
                            span={24}
                            className="blockBreak haberdeliveryaddress"
                          >
                            <div className="boxFormType">
                              <Form.Item
                                name="Contactaddress"
                                // rules={[{ required: true }]}
                                className=""
                              >
                                <GlobalSet>
                                  <div className="checklist-address">
                                    <Checkbox
                                      type="checkbox"
                                      checked={checkedBox}
                                      onChange={onChangeHandlerBox}
                                      disabled={(props.isEditFromIncompleteOrder && props.type === "deckleRecord") || 
                        (props.isEditFromIncompleteOrder && props.type === "orderRecord" && !orderMangtSettings?.data?.edit_after_approval?.value)}
                                      // disabled={(props.isEditFromIncompleteOrder && props.type != "orderRecord") || (!orderMangtSettings?.data?.edit_after_approval?.value)}
                                      />
                                    <p
                                      style={{
                                        fontSize: 14,
                                        fontWeight: 100,
                                      }}
                                    >
                                      The order address is same as PO address
                                    </p>
                                  </div>
                                </GlobalSet>
                                <DisabledStyles>
                                  <Form.Item
                                    name="delivery_address_line_1"
                                    rules={[
                                      { required: true },
                                      { max: 50, message: "Maximum length: 50" },
                                    ]}
                                    initialValue={
                                      details?.delivery_address_line_1
                                    }
                                    className=""
                                  >
                                    <Input
                                    disabled={(checkedBox) || (props.isEditFromIncompleteOrder && props.type === "deckleRecord") || 
                                    (props.isEditFromIncompleteOrder && props.type === "orderRecord" && !orderMangtSettings?.data?.edit_after_approval?.value)}
                                      // disabled={checkedBox || (props.isEditFromIncompleteOrder && props.type != "orderRecord") || (!orderMangtSettings?.data?.edit_after_approval?.value)}
                                      className="disabled-check"
                                      placeholder="First Line of address"
                                    />
                                  </Form.Item>
                                </DisabledStyles>
                              </Form.Item>
                            </div>

                            <div className="boxFormType">
                              <Form.Item
                                name="contact_address"
                                rules={[{}]}
                                className=""
                              >
                                <DisabledStyles>
                                  <Form.Item
                                    name="delivery_address_line_2"
                                    rules={[
                                      { max: 50, message: "Maximum length: 50" },
                                    ]}
                                    initialValue={
                                      details?.delivery_address_line_2
                                    }
                                    className=""
                                  >
                                    <Input
                                    disabled={(checkedBox) || (props.isEditFromIncompleteOrder && props.type === "deckleRecord") || 
                                    (props.isEditFromIncompleteOrder && props.type === "orderRecord" && !orderMangtSettings?.data?.edit_after_approval?.value)}
                                      // disabled={checkedBox || (props.isEditFromIncompleteOrder && props.type != "orderRecord") || (!orderMangtSettings?.data?.edit_after_approval?.value)}
                                      className="disabled-check"
                                      placeholder="Second Line of address"
                                    />
                                  </Form.Item>
                                </DisabledStyles>
                              </Form.Item>
                            </div>

                            <Col span={12} className="d-flex">
                              <div className="boxFormType">
                                <DisabledStyles>
                                  <Form.Item
                                    name="delivery_country"
                                    rules={[{ required: true }]}
                                    initialValue={details?.delivery_country}
                                    className=""
                                  >
                                    <Select
                                      className="disabled-check"
                                      disabled={(checkedBox) || (props.isEditFromIncompleteOrder && props.type === "deckleRecord") || 
                                    (props.isEditFromIncompleteOrder && props.type === "orderRecord" && !orderMangtSettings?.data?.edit_after_approval?.value)}
                                      // disabled={checkedBox || (props.isEditFromIncompleteOrder && props.type != "orderRecord") || (!orderMangtSettings?.data?.edit_after_approval?.value)}
                                      suffixIcon={ isCountryDropdownOpen ? <DropDownSearchDraw/>:<DownArrowDraw />}
                                      onBlur = {OnCountryToggleSelect}
                                      onFocus = {OnCountryToggleSelect}
                                      showSearch
                                      optionFilterProp="children"
                                      filterOption={(input, option) =>
                                        option.children
                                          .toLowerCase()
                                          .includes(input.toLowerCase())
                                      }
                                      onChange={handleProvinceChange}
                                      placeholder="Country"
                                    >
                                      {Country.getAllCountries().map(
                                        (province) => (
                                          <Option key={province.isoCode}>
                                            {province.name}
                                          </Option>
                                        )
                                      )}
                                    </Select>
                                  </Form.Item>
                                </DisabledStyles>
                              </div>
                              <div className="boxFormType">
                                <DisabledStyles>
                                  <Form.Item
                                    name="delivery_state"
                                    rules={[{ required: true }]}
                                    initialValue={details?.delivery_state}
                                    className=""
                                  >
                                    <Select
                                    disabled={(checkedBox) || (props.isEditFromIncompleteOrder && props.type === "deckleRecord") || 
                                    (props.isEditFromIncompleteOrder && props.type === "orderRecord" && !orderMangtSettings?.data?.edit_after_approval?.value)}
                                      // disabled={checkedBox || (props.isEditFromIncompleteOrder && props.type != "orderRecord") || (!orderMangtSettings?.data?.edit_after_approval?.value)}
                                      suffixIcon={ isStateDropdownOpen ? <DropDownSearchDraw/>:<DownArrowDraw />}
                                      onBlur = {OnStateToggleSelect}
                                      onFocus = {OnStateToggleSelect}
                                      showSearch
                                      optionFilterProp="children"
                                      filterOption={(input, option) =>
                                        option.children
                                          .toLowerCase()
                                          .includes(input.toLowerCase())
                                      }
                                      // value={secondCity}
                                      defaultValue="Select State"
                                      onChange={onSecondCityChange}
                                      placeholder="State"
                                    >
                                      {cities.map((city) => (
                                        <Option key={city.name}>
                                          {city.name}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </DisabledStyles>
                              </div>
                            </Col>
                            <Col span={12} className="d-flex">
                              <div
                                className="boxFormType"
                                style={{ marginBottom: "0" }}
                              >
                                <DisabledStyles>
                                  <Form.Item
                                    name="delivery_city"
                                    rules={[
                                      { required: true },
                                      { max: 50, message: "Maximum length: 50" },
                                    ]}
                                    className=""
                                    initialValue={details?.delivery_city}
                                  >
                                    <Input
                                      style={{ textTransform: "capitalize" }}
                                      placeholder="City"
                                      disabled={(checkedBox) || (props.isEditFromIncompleteOrder && props.type === "deckleRecord") || 
                                      (props.isEditFromIncompleteOrder && props.type === "orderRecord" && !orderMangtSettings?.data?.edit_after_approval?.value)}
                                      // disabled={checkedBox || (props.isEditFromIncompleteOrder && props.type != "orderRecord") || (!orderMangtSettings?.data?.edit_after_approval?.value)}
                                      className="disabled-check"
                                    />
                                  </Form.Item>
                                </DisabledStyles>
                              </div>
                              <div className="boxFormType">
                                <DisabledStyles>
                                  <Form.Item
                                    name="zip_code"
                                    rules={[
                                      { required: true },
                                      { min: 6, message: "Minimum length: 6" },
                                      { max: 6, message: "Maximum length: 6" },
                                      {
                                        pattern: new RegExp(/^[0-9]+$/),
                                        message: "Only Numeric value is possible",
                                      },
                                    ]}
                                    className=""
                                    initialValue={details?.delivery_pincode}
                                  >
                                    <Input
                                    disabled={(checkedBox) || (props.isEditFromIncompleteOrder && props.type === "deckleRecord") || 
                                    (props.isEditFromIncompleteOrder && props.type === "orderRecord" && !orderMangtSettings?.data?.edit_after_approval?.value)}
                                      // disabled={checkedBox || (props.isEditFromIncompleteOrder && props.type != "orderRecord") || (!orderMangtSettings?.data?.edit_after_approval?.value)}
                                      className="disabled-check"
                                      placeholder="ZIP code"
                                    />
                                  </Form.Item>
                                </DisabledStyles>
                              </div>
                            </Col>
                          </Col>
                        </DeliveryaddressSpacing>
                      </Row>
                    </Col>
                  </div>

                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Remarks</h5>
                      <p>Any other Information related to the order</p>
                    </div>
                    <Form.Item
                      name="remarks"
                      className=""
                      initialValue={details?.remarks}
                    >
                    <TextArea
                      maxLength={100}
                      style={{ height: 90 }}
                      placeholder="Add Remarks"
                      // disabled={
                      //   props?.selectedState === "Open" ||
                      //   props?.selectedState === "Pending" ||
                      //   props?.selectedState === "Changes Req"
                      // }
                    />
                  </Form.Item>
                  </div>

                  <div className="buttonFlex fixedBtm">
                    <Form.Item>
                      {((props?.selectedState === "Changes Req" || props?.selectedState === "Cancelled" || props?.selectedState === "cancel") || (props?.selectedState === "Approved" && orderMangtSettings?.data?.edit_after_approval?.value && props.type === "orderRecord")) ? (
                        <Button htmlType="submit" className="themeBtn">
                          <Iconmoon icon="addcircle" size={16} color="#ffffff" />{" "}
                          Resend for approval{" "}
                        </Button>
                      ) : (
                        <Button htmlType="submit" className="themeBtn">
                          <Iconmoon icon="addcircle" size={16} color="#ffffff" />{" "}
                          Save{" "}
                        </Button>
                      )}
                    </Form.Item>
                    <Form.Item>
                      <Button
                        key="3"
                        className="textTypeBtn"
                        onClick={() => {
                          cancelChanges();
                        }}
                      >
                        Cancel changes
                      </Button>
                    </Form.Item>
                </div>
                </Form>
              </HaberForm>
            </DetailFields>
          </div>
        </RightDrawerContainer>

        {/* Resend Approval confirmation modal */}
      <ModalPopup visible={isVisibleApprovalModal.visible}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Send for approval?</span>
          <p>
            You cannot make changes to the orders once the order is approved or
            rejected. Are you sure you want to proceed?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => approvalModalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => approvalModalConfirm(isVisibleApprovalModal.data)}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>
      </RightDrawerSidebar>
    ) : null;
};
export default ResendApprovalData;